import {t} from "i18next";

export const RoleType = {
    WP_FI_ADMIN:     { id:  1, type: "WA"},
    WP_FI_USER:      { id:  2, type: "WU"},
    BILLER_ADMIN:    { id:  3, type: "MA"},
    BILLER_USER:     { id:  4, type: "MU"},
    ERPADMIN:        { id:  5, type: "PA"},
    FI_USER_MANAGER: { id:  6, type: "FU"},
    FI_ADMIN:        { id:  7, type: "FA"},
    FI_OPERATOR:     { id:  8, type: "FO"},
    COMPANY_USER:    { id:  9, type: "CA"},
    CEADMIN:         { id: 10, type: "CE"},
    IAMADMIN:        { id: 11, type: "SA"},
    BILLADMIN:       { id: 12, type: "BA"}
};

export const WEBPORTAL_ROLES = [RoleType.WP_FI_ADMIN.id, RoleType.WP_FI_USER.id,
    RoleType.BILLER_ADMIN.id, RoleType.BILLER_USER.id];

export const COMPANY_ROLES = [RoleType.WP_FI_ADMIN.id, RoleType.WP_FI_USER.id, RoleType.COMPANY_USER.id];

/** Role IDs that use FI-initiated / Merchant-initiated trace queue status labels (WP FI Admin, WP FI User). */
export const TRACE_QUEUE_FI_ROLES = [RoleType.WP_FI_ADMIN.id, RoleType.WP_FI_USER.id];

/** Role IDs that use Biller-initiated / FI-initiated trace queue status labels (Biller Admin, Biller User). */
export const TRACE_QUEUE_BILLER_ROLES = [RoleType.BILLER_ADMIN.id, RoleType.BILLER_USER.id];

/** Trace queue row status: who the trace is awaiting response from (I = FI, M = Merchant/Biller). */
export const TraceQueueRowStatus = {
    FI_TO_RESPONSE: "I",
    MERCHANT_TO_RESPONSE: "M"
};

export const FI = {
    DND: 50, BMO: 99, BNS: 2, CIBC: 10, TFX: 88, CTB_BILLER: 777
};

export const Regex = {
    alphaNumeric: /^[0-9A-Za-z]+$/,
    alphaNumericWithSpace: /^[0-9A-Za-z\s]+$/,
    alphaNumericWithHypen: /^[0-9A-Za-z-%\s]+$/,
    alphaNumericWithMarks: /^[0-9A-Za-z-+/*%.,:;!?()\s]+$/,
    firstLastName: /^[a-zA-Z0-9.\-' À-ÿ%]+$/,
    name: /^[!@#$%^&*()`~\-_+=\[\]{}\\|;:'",<.>\?éàèùçâêîôûäëïüöÿœa-z0-9\/ ]+$/i,
    nameWildChar: /^(?:%?[!@#$%^&*()`~\-_+=\[\]{}\\|;:'",<.>\?éàèùçâêîôûäëïüöÿœa-z0-9\/ ]+%?)$/i,
    regularText: /^[-a-z0-9\s._,\"#$'()*+/;=?@{}éàèùçâêîôûäëïüöÿœ]*$/i,
    comment: /^[a-z0-9\s._,\-\"#$'()*+/;=?@{}éàèùçâêîôûäëïüöÿœ]*$/i,
    emailText: /^[a-z0-9._%+\-@]*$/i,
    email: /^[a-z0-9._%+\-]+@[a-z0-9.-]+\.[a-z]{2,}$/i,
    numeric: /^[0-9]+$/,
    decimal2: /^(?:\+|-)?\d*(\.\d{0,2})*$/
};

export const Validators = {
    alphanumeric: {
        test: (v) => Regex.alphaNumeric.test(v),
        error: (fieldLabel) => t("erps.common.errorMessage.field.alphanumeric",
            { fieldLabel: t(fieldLabel || "(missing field label)") }),
    },
    numeric: {
        test: (v) => Regex.numeric.test(v.toString()),
        error: (fieldLabel) => t("erps.common.errorMessage.field.numeric",
            { fieldLabel: t(fieldLabel || "(missing field label)") }),
    },
};

for (const value of Object.values(Validators)) {
    value.validator = true;
}

// Transaction Statuse in tables PCE and RRP (payment_central_enquiry and recalled_rejected_payment)
export const transactionStatusMap = new Map([
    ["A", "erps.common.status.recallApproved"],  ["B", "erps.common.status.pendingApproval"],
    ["C", "erps.common.status.recallCancelled"], ["D", "erps.common.status.originalPaymentProcessed"],
    ["E", "erps.common.status.expired"],         ["F", "erps.common.status.processingCompleted"],
    ["N", "erps.common.status.toBeProcessed"],   ["Q", "erps.common.status.toBeProcessed"],
    ["R", "erps.common.status.recallRejected"],  ["W", "erps.common.status.waitingForAck"],
    ["X", "erps.common.status.paymentFailed"],   ["Z", "erps.common.status.rejectInitiated"],
    ["T", "erps.common.status.traceInitiated"],  ["U", "erps.common.status.traceClosed"],
    ["I", "erps.common.Fi.tracestatus.traceInitiated"], ["M", "erps.common.Biller.tracestatus.traceInitiated"]]);

// export const traceStatusMap = new Map([
//     ["F", "erps.common.Fi.tracestatus.traceInitiated"],  ["M", "erps.common.Biller.tracestatus.traceInitiated"]
// ]);

// Transaction Type in tables PCE and RRP
export const transactionTypes = [
    { value: "RT", name: "erps.transactionManagement.label.showCustomerRecalls" },
    { value: "RJ", name: "erps.transactionManagement.label.showMerchantRejects" }   
];

export const BILLPAY_PORTAL_HOSTNAME = "portal";
export const REFERRER = "referrer";

export const minStartDateAdjustments = {
    "RRH": -180,
    "TH" : -180
};

export const minEndDateAdjustments = {
    "RRH": -179,
    "TH" : -179
};

export const YES_NO_LIST = [
    { label: "erps.common.label.yes", value: "Y" },
    { label: "erps.common.label.no", value: "N" },
];
